import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterBy } from '../../../components/shared/DisplayFilter';

type EmployeeListFilterType = {
  status: FilterBy[];
  pageNo: number;
  searchText: string;
};
const initialEmployeeListFilterState: EmployeeListFilterType = {
  status: [
    {
      key: 'statusText',
      value: [{ id: 'active', label: 'Active' }],
    },
  ],
  pageNo: 0,
  searchText: '',
};

const employeeListFilterSlice = createSlice({
  name: 'employeeListFilter',
  initialState: initialEmployeeListFilterState,
  reducers: {
    setEmployeeListFilter: (
      state,
      action: PayloadAction<EmployeeListFilterType>,
    ) => {
      state.status = action.payload.status ? action.payload.status : [];
      state.pageNo = action.payload.pageNo ? action.payload.pageNo : 0;
      state.searchText = action.payload.searchText
        ? action.payload.searchText
        : '';
    },
    resetEmployeeListFilter: () => initialEmployeeListFilterState,
  },
  extraReducers: (builder) => {
    builder.addCase(
      'RESET_REDUX_APP_STATES',
      () => initialEmployeeListFilterState,
    );
  },
});

export const { setEmployeeListFilter, resetEmployeeListFilter } =
  employeeListFilterSlice.actions;
export default employeeListFilterSlice.reducer;
